// extracted by mini-css-extract-plugin
module.exports = {"specialInduction":"SpecialInduction_specialInduction__J_kZo","drawButton":"SpecialInduction_drawButton__zUboi"};